export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hier"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])}
}